exports.AccountRoleEnum = {
    ADMINISTRATOR: 1,//管理员
    PROJECT_OPERATOR: 2,//工程操作员
    PRODUCTION_TOOL: 3,//生产工具
    CLIENT: 4,//各客户端
    RECORD_OPERATOR: 5,//记录操作员
    BILL_OPERATOR: 6,//账单操作员
    LOCAL_OPERATOR: 7,//现场操作员
    PRODUCTION_OPERATOR: 8,//生产操作员
    QUALITY_OPERATOR: 9,//品质操作员
    INTERNAL_OPERATOR: 10,//内部操作员
    FILE_OPERATOR: 11,//文件操作员
};


// WEBPACK FOOTER //
// ./src/bean/account.js